import { useChat } from "../context/use-chat";
import { Balloon } from "../ui/balloon";

const Dot = () => {
  return <div className="size-2 animate-pulse rounded-full bg-slate-500"></div>;
};

const Dots = () => {
  return (
    <Balloon role="assistant">
      <div className="flex gap-1 px-3">
        <Dot />
        <Dot />
        <Dot />
      </div>
    </Balloon>
  );
};

export const Typing = () => {
  const { isLoading } = useChat();
  return isLoading ? (
    <div className="mt-2 flex animate-fade-in flex-col space-y-2 mb-4">
      <Dots />
    </div>
  ) : null;
};
